module.exports = __webpack_public_path__ + "img/mychoicekeyboarding.e612e250.png";